import Vue from 'vue';
import Vuex from 'vuex';
import * as types from './types';
let defaultUser = window.localStorage.getItem('userCache') || ''
if (defaultUser) {
  defaultUser = JSON.parse(defaultUser)
}
Vue.use(Vuex);
const initPageState = () => {
  let user = {
    token: "",
    catch_components: [],
    // 当前选中的菜单 - 默认选择在架商品
    activePath: '/inShelfGoodManage/list',
    // 菜单项 - 默认包含在架商品
    tabList: [
      { path: '/inShelfGoodManage/list', label: '在架商品管理', name: 'inShelfGoodManageList' }
    ]
  }
  user = Object.assign(user, defaultUser)

  return {
    user,

  }
};
const store = new Vuex.Store({
  // strict: process.env.NODE_ENV !== 'production',
  strict: false,
  state: initPageState(),
  mutations: {
    [types.SAVE_USER](state, user) {
      // console.log(state);
      // console.log(user);
      for (const prop in user) {
        state[prop] = user[prop];
      }
    },
    clearVUEX(state) {
      state.user.catch_components = []
      state.user.activePath = '/inShelfGoodManage/list'
      state.user.tabList = [
        { path: '/inShelfGoodManage/list', label: '在架商品管理', name: 'inShelfGoodManageList' }
      ]
    },
    // 跳转页面执行
    selectMenu(state, submenu) {
      // 在架商品管理就是 wellcome   也就是 home
      if (submenu.name === 'inShelfGoodManageList') {
        submenu.name = 'inShelfGoodManageList'
        submenu.path = '/inShelfGoodManage/list'
      }
      // 当前选中菜单
      // console.log(submenu);
      var activePath = submenu.path
      // 历史已选中菜单列表
      var oldTabList = state.user.tabList
      // 将菜单信息添加到tablist - 添加时判断是否已有该标签
      var result = oldTabList.some(item => {
        if (item.name === activePath) {
          return true
        }
      })
      // 如果不包含该对象，则添加
      if (!result) {
        oldTabList.push({
          path: submenu.name,
          name: submenu.name,
          label: submenu.label
        })
      }
      // 重新赋值
      this.state.user.activePath = activePath
      this.state.user.tabList = oldTabList
    },
    // 添加keepalive缓存
    addKeepAliveCache(state, val) {
      // 如果是在架商品管理不缓存
      if (val === 'inShelfGoodManageList') {
        return
      }
      // 添加时判断，如果该组件已存在，则不添加
      if (state.user.catch_components.indexOf(val) === -1) {
        // 不存在，缓存页面
        state.user.catch_components.push(val)
      }
    },
    // 删除keepalive缓存
    removeKeepAliveCache(state, val) {
      let cache = state.user.catch_components
      for (let i = 0; i < cache.length; i++) {
        if (cache[i] === val) {
          cache.splice(i, 1);
        }
      }
      state.user.catch_components = cache
    },
    //关闭菜单
    closeTab(state, val) {
      // 重新赋值
      state.user.activePath = val.activePath
      state.user.tabList = val.tabList
    },
    // 点击标签选择菜单
    changeMenu(state, val) {
      state.user.activePath = val
    },
  },
  actions: {
    [types.SAVE_USER_CACHE]() {
      let user = this.state.user;
      if (user.id !== "") {
        if (window.localStorage) {
          let ls = window.localStorage;
          let userCache = ls.getItem("userCache");
          if (userCache) {
            ls.removeItem("userCache");
          }
          ls.setItem("userCache", JSON.stringify(user));
        }
      }
    },
    [types.CLEAR_USER_CACHE]() {
      if (window.localStorage) {
        let ls = window.localStorage;
        ls.removeItem("userCache");
      }
    },
    [types.GET_USER_CACHE]() {
      if (window.localStorage) {
        let ls = window.localStorage;
        let userStr = ls.getItem("userCache");
        let user = JSON.parse(userStr);
        this.commit(types.SAVE_USER, {
          user: user
        });
      }
    },
    [types.GET_USER_EXIST]() {
      if (window.localStorage) {
        let ls = window.localStorage;
        let userStr = ls.getItem("userCache");
        return !!userStr;
      }
    }
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/framework/store/index.js